;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Onboarding, PersonalDevelopment, Engagement, Leadership } from '../../../../components/svg/synergiego';
import AcademyOnboarding from '../../../../components/svg/synergiego/AcademyOnboarding';
import AcademyDigital from '../../../../components/svg/synergiego/AcademyDigital';
import AcademyGroup from '../../../../components/svg/synergiego/AcademyGroup';
import AcademyPath from '../../../../components/svg/synergiego/AcademyPath';

export const buttons = [
  { name: 'employers-academy-synergie-academy', link: '#synergie-academy' },
  { name: 'employers-academy-approach', link: '#approach' },
  { name: 'employers-academy-offer', link: '#offer' },
  { name: 'employers-academy-why', link: '#why' },
  { name: 'employers-academy-trainers', link: '#trainers' },
  { name: 'employers-academy-internal-growth', link: '#happy-synergie' },
];

export const timeline = [
  {
    title: 'employers-academy-approach-bullet1-title',
    description: 'employers-academy-approach-bullet1-text',
  },
  {
    title: 'employers-academy-approach-bullet2-title',
    description: 'employers-academy-approach-bullet2-text',
  },
  {
    title: 'employers-academy-approach-bullet3-title',
    description: 'employers-academy-approach-bullet3-text',
  },
  {
    title: 'employers-academy-approach-bullet4-title',
    description: 'employers-academy-approach-bullet4-text',
  },
  {
    title: 'employers-academy-approach-bullet5-title',
    description: 'employers-academy-approach-bullet5-text',
  },
];

export const courses = [
  {
    icon: <Onboarding />,
    title: 'synergiego-advantages-recruit-title',
    description: 'synergiego-advantages-recruit-description',
  },
  {
    icon: <PersonalDevelopment />,
    title: 'synergiego-advantages-communicate-title',
    description: 'synergiego-advantages-communicate-description',
  },
  {
    icon: <Leadership />,
    title: 'synergiego-advantages-faults-title',
    description: 'synergiego-advantages-faults-description',
  },
  {
    icon: <Engagement />,
    title: 'synergiego-advantages-plan-title',
    description: 'synergiego-advantages-plan-description',
  },
];

export const academyHappy = [
  {
    icon: <AcademyOnboarding />,
    description: 'employers-academy-happy-item-1-description',
  },
  {
    icon: <AcademyDigital />,
    description: 'employers-academy-happy-item-2-description',
  },
  {
    icon: <AcademyGroup />,
    description: 'employers-academy-happy-item-3-description',
  },
  {
    icon: <AcademyPath />,
    description: 'employers-academy-happy-item-4-description',
  },
];

export const trainers = [
  {
    name: 'Florentina Smaal',
    jobTitle: 'employers-academy-jobtitle-marketing',
    profilePicture: '/images/academy/florentina.jpg',
  },
  {
    name: 'Inge Dewilde',
    jobTitle: 'employers-academy-jobtitle-performance-management',
    profilePicture: '/images/academy/inge.jpg',
  },
  {
    name: 'Katy Lauwaert',
    jobTitle: 'employers-academy-jobtitle-communication',
    profilePicture: '/images/academy/katy.jpg',
  },
  {
    name: 'Saskia Anthonissen',
    jobTitle: 'employers-academy-jobtitle-stress-management',
    profilePicture: '/images/academy/saskia.jpg',
  },
  {
    name: 'Thomas Mouton',
    jobTitle: 'employers-academy-jobtitle-organisation-efficiency',
    profilePicture: '/images/academy/thomas.jpg',
  },
  {
    name: 'Vincent Van Delm',
    jobTitle: 'employers-academy-jobtitle-ai',
    profilePicture: '/images/academy/vincent.jpg',
  },
  {
    name: 'David Miceli',
    hideNl: true,
    jobTitle: 'employers-academy-jobtitle-safety-coach',
    profilePicture: '/images/academy/david.jpeg',
  },
];
